var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bulk-edit-accounts',{attrs:{"is-loading":_vm.isLoading,"affected-accounts":_vm.affectedAccounts,"users":_vm.users},on:{"edit":_vm.onEdit}})
}
var staticRenderFns = []

export { render, staticRenderFns }